export default {
    BASE_URL: '/admin/member',
    api: [
        {
            name: 'stastic',
            desc: '获取会员统计数据',
            method: 'GET',
            path: '/statistical/',
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/member/stastic.js